import { connect } from "react-redux";
import OnBoarding from "../Components/OnBoarding/OnBoarding";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    user: state.authentication.nickname,
    mail: state.authentication.email,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OnBoarding);
